import { createContext, useContext } from 'react';

import { CurrentMarketplaceUserQuery } from './__generated__/Provider.graphql';

const CurrentMarketplaceUserContext = createContext<
  CurrentMarketplaceUserQuery['currentUser'] | null
>(null);

export const useCurrentMarketplaceUserContext = () =>
  useContext(CurrentMarketplaceUserContext)!;

export const CurrentMarketplaceUserProvider =
  CurrentMarketplaceUserContext.Provider;
